import { TranslationKey, translationKey } from 'intl/types/translationKey';

/**
 * Hover card action tooltips shared across entity preview cards.
 * Keys must exist in `src/intl/locale/messages.*.json`.
 */
export const HoverCardTranslationKeys = {
  EDIT_USER: translationKey('hover_card_edit_user'),
  OPEN_DETAILED_VIEW_USER: translationKey('hover_card_open_detailed_view_user'),
  EDIT_INSPECTION: translationKey('hover_card_edit_inspection'),
  OPEN_DETAILED_VIEW_INSPECTION: translationKey(
    'hover_card_open_detailed_view_inspection'
  ),
  EXPORT_INSPECTION_PDF: translationKey('hover_card_export_inspection_pdf'),
} as const satisfies Record<string, TranslationKey>;
